import { c as _c } from "react/compiler-runtime";
import { type ComponentProps } from 'react';
export const FileIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path id="symbol" fillRule="evenodd" clipRule="evenodd" d="M5 4C5 3.44772 5.44772 3 6 3H13C13.2652 3 13.5196 3.10536 13.7071 3.29289L18.7071 8.29289C18.8946 8.48043 19 8.73478 19 9V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V4ZM7 5V19H17V10H13C12.4477 10 12 9.55228 12 9V5H7ZM14 6.41421L15.5858 8H14V6.41421Z" fill="currentColor" style={{
      fill: "currentColor"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};